import Dashboard from './dashboard';
import TiersContact from './tiers_contact';
import Mission from './mission';
import Tache from './mission_tache/tache';

export default [...Dashboard, ...TiersContact, ...Mission, ...Tache];
